import React from "react";
import { Link } from "react-router-dom";
import {
  Transition
} from 'react-transition-group';
/*
  If the test is in progress, then each ItemCircle is either not answered, answered, or flagged.
  If it's a single student with complete test, each ItemCircle is either right or wrong.
  It it's a group of students, each ItemCircle has a color based on percentage.
*/

/* ItemCircles Test in progress

  <ItemCircle
    number={n + 1}
    uAid={uAid}
    subtestId={props.subtestId}
    active={n + 1 === props.itemNumber}
    completed={props.completed}
    answer={answersByItem[item]}
    key={`ItemCircle${n}`}
  />

*/

export default function ItemCircle({
  number,
  uAid,
  subtestId,
  active,
  completed,
  answer,
  scoring,
  isStudent,
  assessmentId,
  percent,
  selectedStudent,
  correct_answer
}) {
  let itemCircle = null;
  let colorNumber = "";
  let percents = 0;

  if (isStudent === false && answer !== undefined) {
    let key = correct_answer;
    let correct_answer_count = 0;
    let total = 0;
    if (key in answer) {
      correct_answer_count = answer[key];

      Object.keys(answer).map(function (k) {
        total = parseInt(total) + parseInt(answer[k]);
      });
    }
    percents = (correct_answer_count / total) * 100;
    percents = correct_answer_count === 0 ? 0 : percents;

    
    if (percents >= 0 && percents < 34) {
      colorNumber = 1;
    } else if (percents >= 34 && percents <= 67) {
      colorNumber = 2;
    } else if (percents >= 67 && percents <= 100) {
      colorNumber = 3;
    }
  }
  if (!completed) {
    let clActive = "",
      clAnswered = "";
    if (active) {
      clActive = "active";
    }
    if (answer) {
      clAnswered = "answered";
    }
    let query = isStudent ? "" : `&a=${assessmentId}&g=true`;

    if (selectedStudent != "" && selectedStudent !== undefined) {
      query = query + `&s=${selectedStudent}`;
    }
    itemCircle = (
      <Transition
      in={clActive === "active"}
      timeout={300}
      >{ state => (
      <li className={`item-circle item-${state} ${clActive} ${clAnswered}`}>
        <Link
          to={`/assessment/testing/${uAid}/${subtestId}?item=${number}${query}`}
        >
          {number}
        </Link>
      </li>)}
 </Transition>
 

    );
  } else {
    if (scoring === undefined) {
      scoring = {
        raw: 1,
        possible: 1
      };
    }

    const { raw, possible } = scoring;
    if (isStudent === false) {
      percents = (raw / possible) * 100;
      if (percents >= 0 && percents < 34) {
        colorNumber = 1;
      } else if (percents >= 34 && percents <= 67) {
        colorNumber = 2;
      } else if (percents >= 67 && percents <= 100) {
        colorNumber = 3;
      }
    }
    let clActive = "";
    const clAnswered = answer ? " answered" : " not-answered";
    if (active) {
      clActive = "item-circle-active ";
    }
    const clPercent = answer ? `item-circle-color-${colorNumber}` : `item-circle-color-not-answered`;

    const clCorrect = !isStudent ? "" : raw ? " correct" : " incorrect";

    let query = isStudent ? "" : `&a=${assessmentId}&g=true`;
    if (selectedStudent != "" && selectedStudent !== undefined) {
      query = query + `&s=${selectedStudent}`;
    }
    let state = ''
    itemCircle = (
      <React.Fragment>
    
      
  
      <Transition
               in={clActive === "item-circle-active "}
               timeout={300}
              >
     
      
    { state => (  <li
      className={`item-circle item-${state} ${clActive}${clPercent}${clCorrect}${clAnswered}`}
    ><Link
      to={`/assessment/testing/${uAid}/${subtestId}?item=${number}${query}`}
    >
      {number}
    </Link>
      </li>)}
    
     </Transition>
     
      </React.Fragment>
    );
  }
  return itemCircle;
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemCircle.js